"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clock = exports.ClockEnum = void 0;
const react_1 = __importStar(require("react"));
const util_1 = require("../../util");
const Cube_1 = __importDefault(require("./variants/Cube"));
const Analog_1 = __importDefault(require("./variants/Analog"));
const Numvers_1 = __importDefault(require("./variants/Numvers"));
var ClockEnum;
(function (ClockEnum) {
    ClockEnum["CUBE"] = "CUBE";
    ClockEnum["ANALOG"] = "ANALOG";
    ClockEnum["NUMERIC"] = "NUMERIC";
})(ClockEnum || (exports.ClockEnum = ClockEnum = {}));
const Clock = (props) => {
    const { className, mode, custom } = props;
    const [clock, setClock] = (0, react_1.useState)({
        s: 'SS',
        m: 'MM',
        h: 'HH',
    });
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            const date = new Date();
            setClock({
                s: date.getSeconds(),
                m: date.getMinutes(),
                h: date.getHours(),
            });
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    });
    return (react_1.default.createElement("div", { className: (0, util_1.cnx)('glx--clock-main', className) }, (() => {
        if (custom) {
            return custom(clock);
        }
        switch (mode) {
            case ClockEnum.NUMERIC:
                return react_1.default.createElement(Numvers_1.default, { clock: clock });
            case ClockEnum.ANALOG:
                return react_1.default.createElement(Analog_1.default, { clock: clock });
            case ClockEnum.CUBE:
            default:
                return react_1.default.createElement(Cube_1.default, { clock: clock });
        }
    })()));
};
exports.Clock = Clock;
exports.Clock.defaultProps = {
    className: undefined,
    custom: undefined,
    mode: undefined,
};
